import axios from 'axios';
import * as Sentry from '@sentry/vue';

const TIMEOUT = 1000000;
const onRequestSuccess = config => {
  config.timeout = TIMEOUT;
  config.url = `${SERVER_API_URL}${config.url}`;
  return config;
};
const setupAxiosInterceptors = (onUnauthenticated, onServerError) => {
  const onResponseError = err => {
    if (err && (err.status || (err.response && err.response.status))) {
      const status = err.status || err.response.status;
      if (status === 403 || status === 401) {
        return onUnauthenticated(err);
      }
      //aquì regresar a === a 500
      if (status === 500) {
        return onServerError(err);
      }
    } else if (!(err && (err.status || (err.response && err.response.status)))) {
      Sentry.captureMessage(`Excepción sin status ${JSON.stringify(err)}`);
      return onServerError(err);
    }
    return Promise.reject(err);
  };

  if (axios.interceptors) {
    axios.interceptors.request.use(onRequestSuccess);
    axios.interceptors.response.use(res => res, onResponseError);
  }
};

export { onRequestSuccess, setupAxiosInterceptors };
